import 'css-chunksrc/client/common/secondaryCriteriaForm/linkForm/styles.scss';export default {
  "linkForm": "_linkForm_1c5kl_1",
  "inputRoot": "_inputRoot_1c5kl_5",
  "link": "_link_1c5kl_1",
  "emptyLink": "_emptyLink_1c5kl_21",
  "icon": "_icon_1c5kl_28",
  "editIcon": "_editIcon_1c5kl_51",
  "input": "_input_1c5kl_5",
  "listRoot": "_listRoot_1c5kl_67",
  "url": "_url_1c5kl_75",
  "label": "_label_1c5kl_89",
  "group": "_group_1c5kl_95",
  "readOnly": "_readOnly_1c5kl_106",
  "disabled": "_disabled_1c5kl_112",
  "submitButton": "_submitButton_1c5kl_117"
};